// selectors.ts
import { createSelector } from "@ngrx/store";

export const selectAuth = (state) => state.auth;
export const selectUser = createSelector(selectAuth, state => state.user);
export const selectToken = createSelector(selectAuth, state => state.token);
